import React from "react";
import { ShieldCheck, Flag } from "lucide-react";
import { ReportForm } from "../components/ReportForm";

export default function ReportIssue() {
  return (
    <div data-testid="report-page">
      <section className="bg-atlas-navy text-white">
        <div className="max-w-3xl mx-auto px-5 md:px-8 py-14">
          <div className="overline text-atlas-sky mb-3 flex items-center gap-2">
            <Flag className="h-4 w-4" /> Trust &amp; safety
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight">Report an issue</h1>
          <p className="text-slate-300 mt-5 max-w-2xl leading-relaxed">
            Something look inaccurate, misleading or suspicious? Let us know. Reports move through
            Reported → Under Review → Corrected, Removed or Rejected.
          </p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-5 md:px-8 py-12">
        <div className="border border-border rounded-md bg-card p-6 md:p-8">
          <ReportForm />
        </div>
        <div className="mt-6 rounded-md bg-blue-50/60 border border-atlas-blue/20 p-4 flex items-start gap-3">
          <ShieldCheck className="h-5 w-5 text-atlas-blue shrink-0 mt-0.5" />
          <p className="text-sm text-slate-700 leading-relaxed">
            Atlas does not sell vehicles, process vehicle payments, accept deposits or act as escrow.
            If anyone impersonates Atlas to request money, do not pay and report the communication here.
          </p>
        </div>
      </div>
    </div>
  );
}
